// extracted by mini-css-extract-plugin
export var dataCell = "_oh-2";
export var dataRow = "_oh-0";
export var headerRow = "_oh-1";